package com.evoapps.evoshift.ui.start

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.ChevronRight
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.Flag
import androidx.compose.material.icons.filled.Groups
import androidx.compose.material.icons.filled.Layers
import androidx.compose.material.icons.filled.Publish
import androidx.compose.material.icons.filled.RadioButtonUnchecked
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material.icons.filled.SkipNext
import androidx.compose.material.icons.filled.Storefront
import androidx.compose.material.icons.filled.TableChart
import androidx.compose.material.icons.filled.ViewWeek
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.stateDescription
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.usecase.start.FirstRosterStage
import com.evoapps.evoshift.domain.usecase.start.StartPath
import com.evoapps.evoshift.domain.usecase.start.StartStep
import com.evoapps.evoshift.domain.usecase.start.StepState
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.UiText
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.widgets.GoldButton
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.auto_assign
import evoshift.composeapp.generated.resources.first_steps_dismiss
import evoshift.composeapp.generated.resources.first_steps_done
import evoshift.composeapp.generated.resources.first_steps_progress
import evoshift.composeapp.generated.resources.first_steps_team
import evoshift.composeapp.generated.resources.first_steps_to_do
import evoshift.composeapp.generated.resources.start_path_all_set
import evoshift.composeapp.generated.resources.start_path_basics
import evoshift.composeapp.generated.resources.start_path_basics_action
import evoshift.composeapp.generated.resources.start_path_basics_hint
import evoshift.composeapp.generated.resources.start_path_next
import evoshift.composeapp.generated.resources.start_path_publish
import evoshift.composeapp.generated.resources.start_path_publish_action
import evoshift.composeapp.generated.resources.start_path_publish_hint
import evoshift.composeapp.generated.resources.start_path_resume
import evoshift.composeapp.generated.resources.start_path_roster
import evoshift.composeapp.generated.resources.start_path_roster_action_demand
import evoshift.composeapp.generated.resources.start_path_roster_action_new
import evoshift.composeapp.generated.resources.start_path_roster_hint_assign
import evoshift.composeapp.generated.resources.start_path_roster_hint_demand
import evoshift.composeapp.generated.resources.start_path_roster_hint_new
import evoshift.composeapp.generated.resources.start_path_settled
import evoshift.composeapp.generated.resources.start_path_share_calendar
import evoshift.composeapp.generated.resources.start_path_share_hint
import evoshift.composeapp.generated.resources.start_path_share_pdf
import evoshift.composeapp.generated.resources.start_path_skip
import evoshift.composeapp.generated.resources.start_path_skipped
import evoshift.composeapp.generated.resources.start_path_team
import evoshift.composeapp.generated.resources.start_path_team_hint
import evoshift.composeapp.generated.resources.start_path_team_import
import evoshift.composeapp.generated.resources.start_path_team_invite
import evoshift.composeapp.generated.resources.start_path_team_without_app
import evoshift.composeapp.generated.resources.start_path_templates
import evoshift.composeapp.generated.resources.start_path_templates_action
import evoshift.composeapp.generated.resources.start_path_templates_count
import evoshift.composeapp.generated.resources.start_path_templates_hint
import evoshift.composeapp.generated.resources.start_path_title
import evoshift.composeapp.generated.resources.start_path_week
import evoshift.composeapp.generated.resources.start_path_week_action
import evoshift.composeapp.generated.resources.start_path_week_hint
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource

const val START_PATH_TAG = "start_path_card"

object StartPathTags {
    fun step(step: StartStep) = "start_path_step_${step.id}"
    fun open(step: StartStep) = "start_path_open_${step.id}"
    fun skip(step: StartStep) = "start_path_skip_${step.id}"
    fun resume(step: StartStep) = "start_path_resume_${step.id}"
    const val NEXT = "start_path_next"
    const val DISMISS = "start_path_dismiss"
    const val INVITE = "start_path_team_invite"
    const val WITHOUT_APP = "start_path_team_without_app"
    const val IMPORT = "start_path_team_import"
    const val SHARE_PDF = "start_path_share_pdf"
    const val SHARE_CALENDAR = "start_path_share_calendar"
}

/**
 * SH-219: where each step of the start path leads; every one opens its screen on top of the
 * dashboard, and Back returns to the card (read again then). [importTeam] is SH-214's spreadsheet
 * import of the team: null until that screen exists, so the team step offers inviting and adding
 * people without the app only.
 */
class StartPathActions(
    val openBasics: () -> Unit,
    val openShiftTemplates: () -> Unit,
    val openWeek: () -> Unit,
    val invite: () -> Unit,
    val addWithoutApp: () -> Unit,
    val importTeam: (() -> Unit)? = null,
    val createRoster: () -> Unit,
    /** A month at the demand (skeleton) stage: its demand screen. */
    val openDemand: (rosterId: String) -> Unit,
    val autoAssign: (rosterId: String) -> Unit,
    val openRoster: (rosterId: String) -> Unit,
    val emailPdf: (rosterId: String) -> Unit,
    val calendarLink: () -> Unit
)

private val DoneColor = Color(0xFF2E7D32)

/**
 * SH-219: the owner dashboard's start path, "first roster in ten minutes": the progress, the next
 * step opened with its action and Skip, the others to open, skip or resume, and once every step is
 * done or skipped, Hide (with the ways to share a published month with people without the app).
 */
@Composable
fun StartPathCard(
    path: StartPath,
    actions: StartPathActions,
    onSkip: (StartStep) -> Unit,
    onResume: (StartStep) -> Unit,
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
    message: UiText? = null
) {
    RegularCard(modifier = modifier.fillMaxWidth().testTag(START_PATH_TAG)) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.Flag, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(22.dp))
                Spacer(Modifier.width(10.dp))
                Column(Modifier.weight(1f)) {
                    Text(stringResource(Res.string.start_path_title), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = DeepNavy)
                    Text(
                        stringResource(Res.string.first_steps_progress, path.doneCount, StartPath.STEPS),
                        style = MaterialTheme.typography.bodySmall,
                        color = DeepNavy.copy(alpha = 0.8f)
                    )
                }
                if (path.canDismiss) {
                    TextButton(onClick = onDismiss, modifier = Modifier.handCursor().testTag(StartPathTags.DISMISS)) {
                        Text(stringResource(Res.string.first_steps_dismiss), color = DeepNavy, fontWeight = FontWeight.SemiBold)
                    }
                }
            }
            LinearProgressIndicator(
                progress = { path.doneCount.toFloat() / StartPath.STEPS },
                modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp).height(6.dp).clip(RoundedCornerShape(3.dp)),
                color = DarkGold,
                trackColor = DeepNavy.copy(alpha = 0.12f),
                strokeCap = StrokeCap.Round,
                drawStopIndicator = {}
            )
            message?.let { Text(it.asString(), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.error) }

            val next = path.next
            StartStep.entries.forEach { step ->
                StepRow(path, step, expanded = step == next, actions = actions, onSkip = onSkip, onResume = onResume)
            }
            if (path.canDismiss) {
                Text(
                    stringResource(if (path.allDone) Res.string.start_path_all_set else Res.string.start_path_settled),
                    style = MaterialTheme.typography.bodyMedium,
                    color = DeepNavy,
                    modifier = Modifier.padding(top = 4.dp)
                )
            }
        }
    }
}

@Composable
private fun StepRow(
    path: StartPath,
    step: StartStep,
    expanded: Boolean,
    actions: StartPathActions,
    onSkip: (StartStep) -> Unit,
    onResume: (StartStep) -> Unit
) {
    val state = path.state(step)
    val facts = path.facts
    val title = stringResource(titleOf(step))
    val stateText = stringResource(
        when (state) {
            StepState.DONE -> Res.string.first_steps_done
            StepState.SKIPPED -> Res.string.start_path_skipped
            StepState.TO_DO -> Res.string.first_steps_to_do
        }
    )
    val primary = primaryOf(step, path, actions)
    val open = primary.second.takeIf { state == StepState.TO_DO && !expanded }
    Column(
        Modifier.fillMaxWidth().clip(RoundedCornerShape(8.dp))
            .then(if (open != null) Modifier.handCursor().clickable(onClick = open) else Modifier)
            .testTag(StartPathTags.step(step))
            .semantics { stateDescription = stateText }
            .padding(vertical = 6.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Icon(
                when (state) {
                    StepState.DONE -> Icons.Default.CheckCircle
                    StepState.SKIPPED -> Icons.Default.SkipNext
                    StepState.TO_DO -> Icons.Default.RadioButtonUnchecked
                },
                contentDescription = stateText,
                tint = if (state == StepState.DONE) DoneColor else DeepNavy.copy(alpha = 0.7f),
                modifier = Modifier.size(22.dp)
            )
            Spacer(Modifier.width(12.dp))
            Icon(iconOf(step), contentDescription = null, tint = DeepNavy, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Column(Modifier.weight(1f)) {
                Text(
                    if (expanded) stringResource(Res.string.start_path_next, title) else title,
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.SemiBold,
                    color = DeepNavy
                )
                val detail = when {
                    state == StepState.SKIPPED -> stateText
                    state == StepState.DONE && step == StartStep.SHIFT_TEMPLATES ->
                        pluralStringResource(Res.plurals.start_path_templates_count, facts.shiftTemplates, facts.shiftTemplates)
                    state == StepState.DONE && step == StartStep.TEAM ->
                        pluralStringResource(Res.plurals.first_steps_team, facts.teamSize, facts.teamSize)
                    expanded -> stringResource(hintOf(step, facts.rosterStage))
                    else -> null
                }
                detail?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.8f)) }
            }
            when {
                state == StepState.SKIPPED -> TextButton(onClick = { onResume(step) }, modifier = Modifier.handCursor().testTag(StartPathTags.resume(step))) {
                    Text(stringResource(Res.string.start_path_resume), color = DeepNavy, fontWeight = FontWeight.SemiBold)
                }
                open != null -> Icon(Icons.Default.ChevronRight, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(20.dp))
            }
        }
        if (expanded) {
            Column(Modifier.fillMaxWidth().padding(start = 34.dp, top = 8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                GoldButton(primary.first, primary.second, Modifier.fillMaxWidth().testTag(StartPathTags.open(step)))
                if (step == StartStep.TEAM) TeamChoices(actions)
                TextButton(onClick = { onSkip(step) }, modifier = Modifier.align(Alignment.End).handCursor().testTag(StartPathTags.skip(step))) {
                    Text(stringResource(Res.string.start_path_skip), color = DeepNavy, fontWeight = FontWeight.SemiBold)
                }
            }
        }
        // A published month: how it reaches the people without the app.
        if (step == StartStep.PUBLISH && state == StepState.DONE) {
            facts.publishedRosterId?.let { rosterId -> ShareChoices(rosterId, actions) }
        }
    }
}

/** The team step's other ways in: adding without the app and, once SH-214 plugs it in, the import. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun TeamChoices(actions: StartPathActions) {
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        NavyOutlinedButton(stringResource(Res.string.start_path_team_without_app), Icons.Default.Storefront, actions.addWithoutApp, StartPathTags.WITHOUT_APP)
        actions.importTeam?.let { NavyOutlinedButton(stringResource(Res.string.start_path_team_import), Icons.Default.TableChart, it, StartPathTags.IMPORT) }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ShareChoices(rosterId: String, actions: StartPathActions) {
    Column(Modifier.fillMaxWidth().padding(start = 34.dp, top = 8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(stringResource(Res.string.start_path_share_hint), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.8f))
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            NavyOutlinedButton(stringResource(Res.string.start_path_share_pdf), Icons.Default.Email, { actions.emailPdf(rosterId) }, StartPathTags.SHARE_PDF)
            NavyOutlinedButton(stringResource(Res.string.start_path_share_calendar), Icons.Default.CalendarMonth, actions.calendarLink, StartPathTags.SHARE_CALENDAR)
        }
    }
}

@Composable
private fun NavyOutlinedButton(text: String, icon: ImageVector, onClick: () -> Unit, tag: String) {
    OutlinedButton(
        onClick = onClick,
        colors = ButtonDefaults.outlinedButtonColors(contentColor = DeepNavy),
        border = androidx.compose.foundation.BorderStroke(1.dp, DeepNavy.copy(alpha = 0.5f)),
        modifier = Modifier.handCursor().testTag(tag)
    ) {
        Icon(icon, contentDescription = null, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(6.dp))
        Text(text, fontWeight = FontWeight.SemiBold)
    }
}

private fun titleOf(step: StartStep): StringResource = when (step) {
    StartStep.BASICS -> Res.string.start_path_basics
    StartStep.SHIFT_TEMPLATES -> Res.string.start_path_templates
    StartStep.WEEK -> Res.string.start_path_week
    StartStep.TEAM -> Res.string.start_path_team
    StartStep.FIRST_ROSTER -> Res.string.start_path_roster
    StartStep.PUBLISH -> Res.string.start_path_publish
}

private fun hintOf(step: StartStep, stage: FirstRosterStage): StringResource = when (step) {
    StartStep.BASICS -> Res.string.start_path_basics_hint
    StartStep.SHIFT_TEMPLATES -> Res.string.start_path_templates_hint
    StartStep.WEEK -> Res.string.start_path_week_hint
    StartStep.TEAM -> Res.string.start_path_team_hint
    StartStep.FIRST_ROSTER -> when (stage) {
        FirstRosterStage.SKELETON -> Res.string.start_path_roster_hint_demand
        FirstRosterStage.UNASSIGNED -> Res.string.start_path_roster_hint_assign
        else -> Res.string.start_path_roster_hint_new
    }
    StartStep.PUBLISH -> Res.string.start_path_publish_hint
}

private fun iconOf(step: StartStep): ImageVector = when (step) {
    StartStep.BASICS -> Icons.Default.Storefront
    StartStep.SHIFT_TEMPLATES -> Icons.Default.Schedule
    StartStep.WEEK -> Icons.Default.ViewWeek
    StartStep.TEAM -> Icons.Default.Groups
    StartStep.FIRST_ROSTER -> Icons.Default.Layers
    StartStep.PUBLISH -> Icons.Default.Publish
}

/** The step's action: its label and where it leads. */
@Composable
private fun primaryOf(step: StartStep, path: StartPath, actions: StartPathActions): Pair<String, () -> Unit> {
    val facts = path.facts
    return when (step) {
        StartStep.BASICS -> stringResource(Res.string.start_path_basics_action) to actions.openBasics
        StartStep.SHIFT_TEMPLATES -> stringResource(Res.string.start_path_templates_action) to actions.openShiftTemplates
        StartStep.WEEK -> stringResource(Res.string.start_path_week_action) to actions.openWeek
        StartStep.TEAM -> stringResource(Res.string.start_path_team_invite) to actions.invite
        StartStep.FIRST_ROSTER -> {
            val rosterId = facts.rosterId
            when {
                rosterId == null -> stringResource(Res.string.start_path_roster_action_new) to actions.createRoster
                facts.rosterStage == FirstRosterStage.SKELETON -> stringResource(Res.string.start_path_roster_action_demand) to { actions.openDemand(rosterId) }
                else -> stringResource(Res.string.auto_assign) to { actions.autoAssign(rosterId) }
            }
        }
        StartStep.PUBLISH -> {
            val rosterId = facts.rosterId ?: return stringResource(Res.string.start_path_roster_action_new) to actions.createRoster
            stringResource(Res.string.start_path_publish_action) to { actions.openRoster(rosterId) }
        }
    }
}
